import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "SUBSCRIPTION", {
  EDITED: "Subscription edited succesfully",
  DELETED: "Subscription deleted succesfully",
});
